import { useState, useEffect } from 'react';
import { supabase } from './supabase';

// Session cache so we don't re-fetch on every sheet open
const cache = {};

export function useGoogleRating(activityId, name, city, googlePlaceId) {
  const [rating, setRating] = useState(null);
  const [total,  setTotal]  = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!activityId) return;

    // Already cached this session
    if (cache[activityId] !== undefined) {
      setRating(cache[activityId].rating);
      setTotal(cache[activityId].total);
      setLoaded(true);
      return;
    }

    async function fetch() {
      try {
        const { data, error } = await supabase.functions.invoke('google-places', {
          body: {
            activityId,
            name,
            city,
            placeId: googlePlaceId || null,
          },
        });

        if (error || !data) {
          cache[activityId] = { rating: null, total: null };
        } else {
          cache[activityId] = { rating: data.rating, total: data.total };
        }
      } catch {
        cache[activityId] = { rating: null, total: null };
      }

      setRating(cache[activityId].rating);
      setTotal(cache[activityId].total);
      setLoaded(true);
    }

    fetch();
  }, [activityId, name, city, googlePlaceId]);

  return { rating, total, loaded };
}